import React, { useContext, useEffect, useRef, useState } from "react";
import Header3 from "../components/Header3";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import axios from "../AxiosInstance";
import { useAuth } from "../context/auth";
import { BASE_URL } from "../config/BaseUrls";
import { LanguageContext } from "../context/LanguageContext";
import { ChatState } from "../context/ChatProvider";
import { ensureHttps } from "../utils/urlHelpers";

const PersonalPeofile = () => {
  const { lg } = useContext(LanguageContext);

  const [selectedImage, setSelectedImage] = useState(null);
  const fileInputRef = useRef(null);



  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  const [alertVisible, setAlertVisible] = useState(false);

  const handleSaveChanges = () => {
    setAlertVisible(true); // Show the alert
    setAlertVisibleAdd3(false);
    setAlertVisibleAdd2(false);
    setAlertVisibleAdd(false);
    setAlertVisibleAdd4(false);
    setTimeout(() => setAlertVisible(false), 6000); // Hide the alert after 3 seconds
  };

  const handleCloseAlert = () => {
    setAlertVisible(false); // Manually close the alert
  };

  const [alertVisibleAdd, setAlertVisibleAdd] = useState(false);

  const handleSaveChangesAdd = () => {
    setAlertVisibleAdd(true); // Show the alert
    setAlertVisibleAdd3(false);
    setAlertVisibleAdd2(false);
    setAlertVisibleAdd4(false);
    setAlertVisible(false);
    setTimeout(() => setAlertVisibleAdd(false), 6000); // Hide the alert after 3 seconds
  };

  const handleCloseAlertAdd = () => {
    setAlertVisibleAdd(false); // Manually close the alert
  };

  const [alertVisibleAdd2, setAlertVisibleAdd2] = useState(false);

  const handleSaveChangesAdd2 = () => {
    setAlertVisibleAdd2(true); // Show the alert
    setAlertVisibleAdd3(false);
    setAlertVisibleAdd4(false);
    setAlertVisibleAdd(false);
    setAlertVisible(false);
    setTimeout(() => setAlertVisibleAdd2(false), 6000); // Hide the alert after 3 seconds
  };

  const handleCloseAlertAdd2 = () => {
    setAlertVisibleAdd2(false); // Manually close the alert
  };

  const [alertVisibleAdd3, setAlertVisibleAdd3] = useState(false);

  const handleSaveChangesAdd3 = () => {
    setAlertVisibleAdd3(true); // Show the alert
    setAlertVisibleAdd4(false);
    setAlertVisibleAdd2(false);
    setAlertVisibleAdd(false);
    setAlertVisible(false);
    setTimeout(() => setAlertVisibleAdd3(false), 6000); // Hide the alert after 3 seconds
  };

  const handleCloseAlertAdd3 = () => {
    setAlertVisibleAdd3(false); // Manually close the alert
  };

  const [alertVisibleAdd4, setAlertVisibleAdd4] = useState(false);

  const handleSaveChangesAdd4 = () => {
    setAlertVisibleAdd4(true); // Show the alert
    setAlertVisibleAdd3(false);
    setAlertVisibleAdd2(false);
    setAlertVisibleAdd(false);
    setAlertVisible(false);

    setTimeout(() => setAlertVisibleAdd4(false), 6000); // Hide the alert after 3 seconds
  };

  const handleCloseAlertAdd4 = () => {
    setAlertVisibleAdd4(false); // Manually close the alert
  };

  const [alertVisibleAdd5, setAlertVisibleAdd5] = useState(false);

  const handleSaveChangesAdd5 = () => {
    setAlertVisibleAdd5(true); // Show the alert
    setAlertVisibleAdd4(false); // Show the alert

    setAlertVisibleAdd3(false);
    setAlertVisibleAdd2(false);
    setAlertVisibleAdd(false);
    setAlertVisible(false);

    setTimeout(() => setAlertVisibleAdd5(false), 6000); // Hide the alert after 3 seconds
  };

  const handleCloseAlertAdd5 = () => {
    setAlertVisibleAdd5(false); // Manually close the alert
  };
  //=========================== INTGRATION ================================
  const [auth, setAuth] = useAuth(); // If using Context API
  const {
    selectedChat,
    setSelectedChat,
    user,
    setUser,
    notification,
    setChats,
    setNotification,
  } = ChatState();
  const userId = auth?.user?._id;

  // const [user, setUser] = useState({
  //   name: "",
  //   city: "",
  //   country: "",
  //   dateOfBirth: "",
  //   gender: "",
  //   aboutMe: "",
  //   storeName: "",
  //   storeAddress: "",
  //   surName: "",
  //   favoriteGenres: "",
  //   fbLinks: [],
  //   instaLinks: [],
  //   tiktokLinks: [],
  //   xLinks: [],
  //   linkdlnLinks: [],
  // });
  // useEffect(() => { 
  //   user1 && setUser(user1);

  // }
  // , [user1]);
  const [imageFile, setImageFile] = useState()
  useEffect(() => {
    const fetchUser = async () => {
      if (!userId) return; // Don't make API call if userId is undefined
      try {
        const res = await axios.get(`api/v1/auth/user-profile/${userId}`);
        setUser(res.data.data);
      } catch (err) {
        console.error("Error:", err);
      }
    };

    fetchUser();
  }, [userId]);
  // ✅ Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUser((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Save file to state for backend upload
      setUser((prevUser) => ({
        ...prevUser,
        imageFile: file, // 👈 this is needed to send file to FormData
      }));
      setImageFile(file)
      // Show preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const formatDate = (date) => {
    if (!date) return ""; // If no date is present, return empty string
    return date.split("T")[0]; // Split by 'T' and return only the date part
  };


  const handleUpdateProfile = async (e) => {
    e.preventDefault()
    try {
      const formData = new FormData();

      // Append all your profile fields
      formData.append("name", user.name);
      formData.append("storeName", user.storeName);
      formData.append("storeAddress", user.storeAddress);

      formData.append("surName", user.surName || "");
      formData.append("favoriteGenres", user.favoriteGenres || "");
      formData.append("city", user.city || "");
      formData.append("country", user.country || "");
      formData.append("dateOfBirth", user?.dateOfBirth || "");
      formData.append("gender", user.gender || "");
      formData.append("fbLinks", user.fbLinks || "");
      formData.append("instaLinks", user.instaLinks || "");
      formData.append("tiktokLinks", user.tiktokLinks || "");
      formData.append("xLinks", user.xLinks || "");
      formData.append("linkdlnLinks", user.linkdlnLinks || "");
      formData.append("aboutMe", user.aboutMe || "");

      // Append image if available
      if (imageFile) {
        formData.append("image", imageFile);
      }

      const response = await axios.put(
        `api/v1/auth/update-profile/${userId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.success) {
        setUser(response.data.data); // Update frontend state
        handleSaveChanges(true); // Close editing mode
      }
    } catch (error) {
      console.error("Error updating profile:", error);
      toast.error("Error updating profile");
    }
  };

  //====================INTGRATION======================

  return (
    <>
      <div className="profilheder">
        <Header3 />
      </div>

      {/* Alert */}

      {alertVisible && (
        <div
          style={{
            position: "absolute", // Overlay on top
            top: "1%",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "orange",
            color: "white",
            padding: "10px 10px",
            borderRadius: "5px",
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            zIndex: 1000,
          }}
        >
          {/* Tick Icon */}
          <div
            style={{
              backgroundColor: "white",
              color: "green",
              borderRadius: "50%",
              width: "24px",
              height: "24px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: "10px",
              fontWeight: "bold",
              fontSize: "16px",
              border: "1px solid green",
            }}
          >
            ✓
          </div>
          <div className="fontmobil" style={{ flex: 1 }}>
            Your profile information has been updated
          </div>
          {/* Close Icon */}
          <div
            style={{
              cursor: "pointer",
              marginLeft: "10px",
              color: "white",
              fontWeight: "bold",
              fontSize: "18px",
            }}
            onClick={handleCloseAlert}
          >
            ×
          </div>
        </div>
      )}

      {alertVisibleAdd && (
        <div
          style={{
            position: "absolute", // Overlay on top
            top: "1%",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "orange",
            color: "white",
            padding: "10px 10px",
            borderRadius: "5px",
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            // width: "400px",
            // boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            zIndex: 1000,
          }}
        >
          {/* Tick Icon */}
          <div
            style={{
              backgroundColor: "white",
              color: "green",
              borderRadius: "50%",
              width: "24px",
              height: "24px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: "10px",
              fontWeight: "bold",
              fontSize: "16px",
              border: "1px solid green",
            }}
          >
            ✓
          </div>
          <div className="fontmobil" style={{ flex: 1 }}>
            Your Facebook link has been updated
          </div>
          {/* Close Icon */}
          <div
            style={{
              cursor: "pointer",
              marginLeft: "10px",
              color: "white",
              fontWeight: "bold",
              fontSize: "18px",
            }}
            onClick={handleCloseAlertAdd}
          >
            ×
          </div>
        </div>
      )}

      {alertVisibleAdd2 && (
        <div
          style={{
            position: "absolute", // Overlay on top
            top: "1%",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "orange",
            color: "white",
            padding: "10px 10px",
            borderRadius: "5px",
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            // width: "400px",
            // boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            zIndex: 1000,
          }}
        >
          {/* Tick Icon */}
          <div
            style={{
              backgroundColor: "white",
              color: "green",
              borderRadius: "50%",
              width: "24px",
              height: "24px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: "10px",
              fontWeight: "bold",
              fontSize: "16px",
              border: "1px solid green",
            }}
          >
            ✓
          </div>
          <div className="fontmobil" style={{ flex: 1 }}>
            Your Instagram link has been updated
          </div>
          {/* Close Icon */}
          <div
            style={{
              cursor: "pointer",
              marginLeft: "10px",
              color: "white",
              fontWeight: "bold",
              fontSize: "18px",
            }}
            onClick={handleCloseAlertAdd2}
          >
            ×
          </div>
        </div>
      )}

      {alertVisibleAdd3 && (
        <div
          style={{
            position: "absolute", // Overlay on top
            top: "1%",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "orange",
            color: "white",
            padding: "10px 10px",
            borderRadius: "5px",
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            // width: "400px",
            // boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            zIndex: 1000,
          }}
        >
          {/* Tick Icon */}
          <div
            style={{
              backgroundColor: "white",
              color: "green",
              borderRadius: "50%",
              width: "24px",
              height: "24px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: "10px",
              fontWeight: "bold",
              fontSize: "16px",
              border: "1px solid green",
            }}
          >
            ✓
          </div>
          <div className="fontmobil" style={{ flex: 1 }}>
            Your X link has been updated
          </div>
          {/* Close Icon */}
          <div
            style={{
              cursor: "pointer",
              marginLeft: "10px",
              color: "white",
              fontWeight: "bold",
              fontSize: "18px",
            }}
            onClick={handleCloseAlertAdd3}
          >
            ×
          </div>
        </div>
      )}

      {alertVisibleAdd4 && (
        <div
          style={{
            position: "absolute", // Overlay on top
            top: "1%",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "orange",
            color: "white",
            padding: "10px 10px",
            borderRadius: "5px",
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            // width: "400px",
            // boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            zIndex: 1000,
          }}
        >
          {/* Tick Icon */}
          <div
            style={{
              backgroundColor: "white",
              color: "green",
              borderRadius: "50%",
              width: "24px",
              height: "24px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: "10px",
              fontWeight: "bold",
              fontSize: "16px",
              border: "1px solid green",
            }}
          >
            ✓
          </div>
          <div className="fontmobil" style={{ flex: 1 }}>
            Your Linkedin link has been updated
          </div>
          {/* Close Icon */}
          <div
            style={{
              cursor: "pointer",
              marginLeft: "10px",
              color: "white",
              fontWeight: "bold",
              fontSize: "18px",
            }}
            onClick={handleCloseAlertAdd4}
          >
            ×
          </div>
        </div>
      )}

      {alertVisibleAdd5 && (
        <div
          style={{
            position: "absolute", // Overlay on top
            top: "1%",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "orange",
            color: "white",
            padding: "10px 10px",
            borderRadius: "5px",
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            // width: "400px",
            // boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            zIndex: 1000,
          }}
        >
          {/* Tick Icon */}
          <div
            style={{
              backgroundColor: "white",
              color: "green",
              borderRadius: "50%",
              width: "24px",
              height: "24px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: "10px",
              fontWeight: "bold",
              fontSize: "16px",
              border: "1px solid green",
            }}
          >
            ✓
          </div>
          <div className="fontmobil" style={{ flex: 1 }}>
            Your Tik Tok link has been updated
          </div>
          {/* Close Icon */}
          <div
            style={{
              cursor: "pointer",
              marginLeft: "10px",
              color: "white",
              fontWeight: "bold",
              fontSize: "18px",
            }}
            onClick={handleCloseAlertAdd5}
          >
            ×
          </div>
        </div>
      )}

      <div className="container mx-auto px-4 lg:!px-0 py-6">
        <div className="flex flex-col lg:flex-row gap-6 lg:gap-8">
          {/* Sidebar */}
          <div className="w-full lg:w-64 flex-shrink-0">
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
              {/* Profile Image Section */}
              <div className="flex flex-col items-center mb-6">
                <input
                  type="file"
                  accept="image/*"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />
                {user && (
                  <div className="relative mb-4">
                    <img
                      src={
                        selectedImage ||
                        (user?.profileImage
                          ? user?.profileImage?.startsWith("http")
                            ? ensureHttps(user?.profileImage) // ✅ external URL - ensure HTTPS
                            : ensureHttps(`${BASE_URL}/uploads/${user?.profileImage}`) // ✅ internal URL - ensure HTTPS
                          : require("../pages/image/addphotoiconplus.png"))
                      }
                      alt="Profile"
                      className="rounded-full w-24 h-24 object-cover cursor-pointer border-2 border-gray-200 hover:border-[#34C3C9] transition-colors"
                      onClick={handleButtonClick}
                    />
                    <div className="absolute bottom-0 right-0 bg-[#34C3C9] rounded-full p-1.5 cursor-pointer hover:bg-[#2BB3BA] transition-colors">
                      <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                      </svg>
                    </div>
                  </div>
                )}
                <h2 className="text-xl font-bold text-gray-900 mb-2">{user?.name}</h2>
                <button
                  type="button"
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
                  onClick={handleButtonClick}
                >
                  {lg?.uploadp || "Update photo"}
                </button>
              </div>

              {/* Navigation Links */}
              <div className="space-y-2 border-t border-gray-200 pt-4">
                <Link
                  to="/profile"
                  className="flex items-center px-2 py-2.5 text-base font-semibold text-[#34C3C9] bg-[#34C3C91a] rounded-lg"
                >
                  {lg?.pprofile || "Personal Profile"}
                </Link>
                <Link
                  to="/accountnotification"
                  className="flex items-center px-2 py-2.5 text-base font-medium text-gray-700 hover:bg-gray-50 rounded-lg transition-colors"
                >
                  {lg?.accnotifi || "Account Notification"}
                </Link>
                {user?.seller === "Yes" && (
                  <Link
                    to="/personal-seller"
                    className="flex items-center px-2 py-2.5 text-base font-medium text-gray-700 hover:bg-gray-50 rounded-lg transition-colors"
                  >
                    Bookseller's details
                  </Link>
                )}
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="flex-1">
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 lg:p-8">
              <form onSubmit={handleUpdateProfile} className="space-y-6">
                {/* Personal Information Section */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label htmlFor="name" className="block text-sm font-semibold text-gray-700 mb-2">
                      {lg?.name || "Name"}*
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={user?.name || ""}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900"
                    />
                  </div>

                  <div>
                    <label htmlFor="surname" className="block text-sm font-semibold text-gray-700 mb-2">
                      {lg?.surname || "Surname"}
                    </label>
                    <input
                      type="text"
                      id="surname"
                      name="surName"
                      value={user?.surName || ""}
                      onChange={handleInputChange}
                      className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900"
                    />
                  </div>

                  <div>
                    <label htmlFor="dateOfBirth" className="block text-sm font-semibold text-gray-700 mb-2">
                      {lg?.dob || "Date of Birth"}
                    </label>
                    <input
                      type="date"
                      id="dateOfBirth"
                      name="dateOfBirth"
                      value={formatDate(user?.dateOfBirth || "")}
                      onChange={handleInputChange}
                      className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900"
                    />
                  </div>

                  <div>
                    <label htmlFor="gender" className="block text-sm font-semibold text-gray-700 mb-2">
                      {lg?.gender || "Gender"}
                    </label>
                    <select
                      id="gender"
                      name="gender"
                      value={user?.gender || ""}
                      onChange={handleInputChange}
                      className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900 bg-white"
                    >
                      <option value="">Select gender</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>

                  <div>
                    <label htmlFor="city" className="block text-sm font-semibold text-gray-700 mb-2">
                      {lg?.city || "City"}
                    </label>
                    <input
                      type="text"
                      id="city"
                      name="city"
                      value={user?.city || ""}
                      onChange={handleInputChange}
                      className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900"
                    />
                  </div>

                  <div>
                    <label htmlFor="country" className="block text-sm font-semibold text-gray-700 mb-2">
                      {lg?.country || "Country"}
                    </label>
                    <input
                      type="text"
                      id="country"
                      name="country"
                      value={user?.country || ""}
                      onChange={handleInputChange}
                      className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900"
                    />
                  </div>

                  <div className="md:col-span-2">
                    <label htmlFor="favoriteGenres" className="block text-sm font-semibold text-gray-700 mb-2">
                      {lg?.favgenre || "Favorite Genres"}
                    </label>
                    <input
                      type="text"
                      id="favoriteGenres"
                      name="favoriteGenres"
                      value={user?.favoriteGenres || ""}
                      onChange={handleInputChange}
                      className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900"
                    />
                  </div>
                </div>

                {/* Social Media Section */}
                <div className="border-t border-gray-200 pt-6 mt-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-1">Social Media</h3>
                  <p className="text-sm text-gray-600 mb-4">{lg?.asmedia || "Add your social media below."}</p>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    {/* Facebook */}
                    <div>
                      <label htmlFor="fbLinks" className="block text-xs font-semibold text-gray-700 mb-1">
                        Facebook
                      </label>
                      {user?.fbLinks && (
                        <a
                          href={user.fbLinks}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="block text-xs text-[#34C3C9] hover:underline mb-1 truncate"
                        >
                          {user.fbLinks}
                        </a>
                      )}
                      <div className="flex gap-2">
                        <input
                          type="text"
                          id="fbLinks"
                          name="fbLinks"
                          value={user?.fbLinks || ""}
                          onChange={handleInputChange}
                          placeholder="Facebook URL"
                          className="flex-1 px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900"
                        />
                        <button
                          type="button"
                          onClick={handleSaveChangesAdd}
                          className="px-3 py-2 text-xs font-semibold text-[#34C3C9] hover:text-[#2BB3BA] transition-colors whitespace-nowrap"
                        >
                          Add
                        </button>
                      </div>
                    </div>

                    {/* Instagram */}
                    <div>
                      <label htmlFor="instaLinks" className="block text-xs font-semibold text-gray-700 mb-1">
                        Instagram
                      </label>
                      {user?.instaLinks && (
                        <a
                          href={user.instaLinks}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="block text-xs text-[#34C3C9] hover:underline mb-1 truncate"
                        >
                          {user.instaLinks}
                        </a>
                      )}
                      <div className="flex gap-2">
                        <input
                          type="text"
                          id="instaLinks"
                          name="instaLinks"
                          value={user?.instaLinks || ""}
                          onChange={handleInputChange}
                          placeholder="Instagram URL"
                          className="flex-1 px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900"
                        />
                        <button
                          type="button"
                          onClick={handleSaveChangesAdd2}
                          className="px-3 py-2 text-xs font-semibold text-[#34C3C9] hover:text-[#2BB3BA] transition-colors whitespace-nowrap"
                        >
                          Add
                        </button>
                      </div>
                    </div>

                    {/* X (Twitter) */}
                    <div>
                      <label htmlFor="xLinks" className="block text-xs font-semibold text-gray-700 mb-1">
                        X (Twitter)
                      </label>
                      {user?.xLinks && (
                        <a
                          href={user.xLinks}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="block text-xs text-[#34C3C9] hover:underline mb-1 truncate"
                        >
                          {user.xLinks}
                        </a>
                      )}
                      <div className="flex gap-2">
                        <input
                          type="text"
                          id="xLinks"
                          name="xLinks"
                          value={user?.xLinks || ""}
                          onChange={handleInputChange}
                          placeholder="X URL"
                          className="flex-1 px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900"
                        />
                        <button
                          type="button"
                          onClick={handleSaveChangesAdd3}
                          className="px-3 py-2 text-xs font-semibold text-[#34C3C9] hover:text-[#2BB3BA] transition-colors whitespace-nowrap"
                        >
                          Add
                        </button>
                      </div>
                    </div>

                    {/* TikTok */}
                    <div>
                      <label htmlFor="tiktokLinks" className="block text-xs font-semibold text-gray-700 mb-1">
                        TikTok
                      </label>
                      {user?.tiktokLinks && (
                        <a
                          href={user.tiktokLinks}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="block text-xs text-[#34C3C9] hover:underline mb-1 truncate"
                        >
                          {user.tiktokLinks}
                        </a>
                      )}
                      <div className="flex gap-2">
                        <input
                          type="text"
                          id="tiktokLinks"
                          name="tiktokLinks"
                          value={user?.tiktokLinks || ""}
                          onChange={handleInputChange}
                          placeholder="TikTok URL"
                          className="flex-1 px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900"
                        />
                        <button
                          type="button"
                          onClick={handleSaveChangesAdd5}
                          className="px-3 py-2 text-xs font-semibold text-[#34C3C9] hover:text-[#2BB3BA] transition-colors whitespace-nowrap"
                        >
                          Add
                        </button>
                      </div>
                    </div>

                    {/* LinkedIn */}
                    <div>
                      <label htmlFor="linkdlnLinks" className="block text-xs font-semibold text-gray-700 mb-1">
                        LinkedIn
                      </label>
                      {user?.linkdlnLinks && (
                        <a
                          href={user.linkdlnLinks}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="block text-xs text-[#34C3C9] hover:underline mb-1 truncate"
                        >
                          {user.linkdlnLinks}
                        </a>
                      )}
                      <div className="flex gap-2">
                        <input
                          type="text"
                          id="linkdlnLinks"
                          name="linkdlnLinks"
                          value={user?.linkdlnLinks || ""}
                          onChange={handleInputChange}
                          placeholder="LinkedIn URL"
                          className="flex-1 px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900"
                        />
                        <button
                          type="button"
                          onClick={handleSaveChangesAdd4}
                          className="px-3 py-2 text-xs font-semibold text-[#34C3C9] hover:text-[#2BB3BA] transition-colors whitespace-nowrap"
                        >
                          Add
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* About Me Section */}
                <div className="border-t border-gray-200 pt-6 mt-6">
                  <label htmlFor="aboutMe" className="block text-sm font-semibold text-gray-700 mb-2">
                    {lg?.aboutme || "About me"}
                  </label>
                  <textarea
                    id="aboutMe"
                    name="aboutMe"
                    rows={4}
                    value={user?.aboutMe || ""}
                    onChange={handleInputChange}
                    placeholder="Tell us about yourself..."
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900 resize-none"
                  />
                </div>

                {/* Save Button */}
                <div className="flex justify-end pt-4 border-t border-gray-200">
                  <button
                    type="submit"
                    className="px-8 py-3 bg-[#34C3C9] hover:bg-[#2BB3BA] text-white font-semibold rounded-lg transition-all duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
                  >
                    {lg?.savechgbtn || "Save Changes"}
                  </button>
                </div>
              </form>

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PersonalPeofile;
